var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cafe-pdf-holder"},[_c('cafePdf',{ref:"pdf",attrs:{"id":"cafe-pdf","filePath":_vm.pdfUrl}}),_c('div',{staticClass:"cafe-pdf-footer"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }